import { DynamicStandaloneProse } from '@/components/Prose';
import { propClassName } from '@/styles/TextMultiline';
import { ClassNameProp, Component } from '@/types/component';
import { ProseProps } from 'base/components/Prose/Prose';
import { cn } from 'lib/utils/cn';

export interface TextMultilineProps extends Omit<ProseProps, 'markup'> {
  colors?: ClassNameProp;
  markup?: string;
  size?: ClassNameProp;
  variant?: ClassNameProp;
}
const TextMultilineComponent: Component<TextMultilineProps> = ({
  className,
  colors,
  markup,
  size,
  variant,
  ...props
}) => {
  const colorsClassName = propClassName('colors', colors);
  const sizeClassName = propClassName('size', size);
  const variantClassName = propClassName('variant', variant);
  const componentClassName = cn(colorsClassName, sizeClassName, variantClassName, className);

  return <DynamicStandaloneProse options={{ className: componentClassName }} {...{ markup }} {...props} />;
};

export const TextMultiline = TextMultilineComponent;
